<!-- <p-toast position="top-right"></p-toast> -->
<div class="login-body">
    <div class="card login-panel ui-fluid LoginAdminMain">
        <form #loginForm="ngForm" (ngSubmit)="login()">
            <div class="p-g" class="formDiv">
                <div class="formInnerData">
                    <div>
                        <img style="border: 1px solid black;
                        padding: 7px;
                        border-radius: 10em;" src="assets/layout/images/gym.png">
                    </div>
                    <div class="p-g-12 inputMainDiv">
                        <div class="p-g-12">
                            <span class="md-inputfield">
                                <input type="text" name="GymId" class="inputDiv" [(ngModel)]="gymId" #GymId="ngModel"
                                    id="gymId" required autocomplete="off" pInputText>
                                <label>Gym Id</label>
                            </span>
                        </div>
                        <div class="p-g-12">
                            <span class="md-inputfield">
                                <input type="text" class="inputDiv" name="email" [(ngModel)]="user.email"
                                    #email="ngModel" required autocomplete="off" pInputText>
                                <label>Username</label>
                            </span>
                        </div>
                        <div class="p-g-12">
                            <span class="md-inputfield">
                                <input type="{{passwordType}}" class="inputDiv" name="password"
                                    [(ngModel)]="user.password" #password="ngModel" required autocomplete="off"
                                    pInputText>
                                <label>Password</label>
                                <span (click)="togglePasswordType()"><i
                                        style="position: relative;top: -26px; color: black;"
                                        class="ui-icon-remove-red-eye showHidePassword"></i> </span>
                            </span>
                        </div>
                    </div>
                    <!-- <div *ngIf="isCaptchaShow" class="recaptchaDiv">
                        <div class="card-body">
                            <div #recaptcha></div>
                        </div>
                    </div> -->
                    <div class="p-g-12 btnDiv">
                        <button [disabled]="loading || !loginForm.valid" pButton type="submit" label="Sign In"
                            class="signinBtnDiv " icon="ui-icon-person">
                            <div *ngIf="loading"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                                    animationDuration=".5s"></p-progressSpinner></div>
                        </button>
                        <!-- <button *ngIf="isCaptchaShow" pButton class="signinBtnDiv" type="button" label="Sign In"
                            (click)="verifyReCaptcha()" style="width: 100%; border-radius: 5px;" icon="ui-icon-person"
                            [disabled]="!loginForm.valid || isDisableSignin">
                            <div *ngIf="loading"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                                    animationDuration=".5s"></p-progressSpinner></div>
                        </button> -->
                        <!-- <button pButton type="button" routerLink="/reset" label="Forgot Password" style="width: 100%"
                        class="pink-btn" icon="ui-icon-help"></button> --> &nbsp;&nbsp;
                        <!-- <br> -->
                        <!-- <button pButton type="button" routerLink="/register" label="Sign Up" class="signupBtnDiv"
                            icon="ui-icon-person"></button> -->
                    </div>
                    <!-- <div class="ui-g-12">
                    <div class="card bg-danger" style="max-width: 18rem;background-color: cornsilk; color: maroon;">
                        <div class="card-body">
                            <div *ngIf="error"  id="card-text" [innerHtml]="errorMessage"></div>
                        </div>
                    </div>
                </div> -->
                </div>
            </div>
        </form>
    </div>
</div>